import type { QueueItem } from '../queue';
import type { IQueueStorage, StorageHealth } from './IQueueStorage';

const LS_KEY = 'GOMARKE_QUEUE_V2';

export class LocalStorageQueueStorage implements IQueueStorage {
  readonly name = 'localstorage';

  async loadAll(): Promise<QueueItem[]> {
    if (typeof window === 'undefined') return [];
    try {
      const raw = window.localStorage.getItem(LS_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw) as unknown;
      return Array.isArray(parsed) ? (parsed as QueueItem[]) : [];
    } catch {
      return [];
    }
  }

  async saveAll(items: QueueItem[]): Promise<void> {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.setItem(LS_KEY, JSON.stringify(items));
    } catch {
      // quota
    }
  }

  async put(item: QueueItem): Promise<void> {
    const all = await this.loadAll();
    const idx = all.findIndex(i => i.id === item.id);
    if (idx >= 0) all[idx] = item;
    else all.push(item);
    await this.saveAll(all);
  }

  async delete(id: string): Promise<void> {
    const all = await this.loadAll();
    await this.saveAll(all.filter(i => i.id !== id));
  }

  async health(): Promise<StorageHealth> {
    const items = await this.loadAll();
    const bytes = new TextEncoder().encode(JSON.stringify(items)).length;
    return {
      ok: true,
      backend: 'localstorage',
      itemCount: items.length,
      estimatedBytes: bytes,
    };
  }
}
